export default "__VITE_ASSET__CxvjpD9d__"